import { Stack, Typography } from "@mui/material";
import Iconify from "src/components/Iconify";

import { EntityData } from "../useGetEntitiesData";

export default function Success({ countReady }: EntityData) {
	return (
		<Stack direction={"row"} alignItems='center' gap={1} justifyContent={"center"}>
			<Iconify icon={"mdi:success"} color='success.main' width={14} />
			<Typography variant='body2'>{countReady}</Typography>
		</Stack>
	);
}
